import React from "react";
import styles from "./ShoppingCart.module.css";
import { PiHeartFill } from "react-icons/pi";

function ShoppingCart({ shopping }) {
  return (
    <button onClick={shopping} className={styles.btnCart}>
      <PiHeartFill className={styles.shoppingCart}></PiHeartFill>
    </button>
  );
}

export { ShoppingCart };
